interface BrandMarkProps {
  compact?: boolean;
}

export function BrandMark({ compact = false }: BrandMarkProps) {
  return (
    <div
      className={`brand-mark${compact ? " brand-mark--compact" : ""}`}
      role="img"
      aria-label="项目标识"
    >
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="28" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 40h42M17 38l4-17h22l4 17M24 21v17m16-17v17M27 27h10" />
        <circle cx="32" cy="14" r="2.5" className="brand-mark__signal" />
      </svg>
      {!compact && (
        <div>
          <span>数字仿真实验</span>
          <strong>中国共产党是全民族抗日战争的中流砥柱</strong>
        </div>
      )}
    </div>
  );
}
